import { ADMISSION_TYPE_GUEST_LIST } from '@domain/admission';

import { type AdmissionFlow, type AdmissionFormType, type SectionKey } from './admission-form.type';
import {
  ADMISSION_FORM_FLOW_ADMISSION,
  ADMISSION_FORM_FLOW_PRESET,
  ADMISSION_FORM_TYPE_PASS,
  SECTION_ORDER,
} from './constants';

export interface SectionVisibilityContext {
  flow: AdmissionFlow;
  type: AdmissionFormType;
  isClubCountryItaly: boolean;
  hasItalyRegulationContext: boolean;
  isSuperAdmin: boolean;
  canExcludeSiaeOffers: boolean;
}

export const getVisibleSections = ({
  flow,
  type,
  isClubCountryItaly,
  hasItalyRegulationContext,
  isSuperAdmin,
  canExcludeSiaeOffers,
}: SectionVisibilityContext): SectionKey[] => {
  const isPass = type === ADMISSION_FORM_TYPE_PASS;
  const isAdmissionFlow = flow === ADMISSION_FORM_FLOW_ADMISSION;
  const isPreset = flow === ADMISSION_FORM_FLOW_PRESET;

  const visible: Record<SectionKey, boolean> = {
    basicInfo: true,
    // Channels/access-code/quota apply in every flow: event admissions, passes, and presets (BE
    // accepts `distribution` on presets, B2B-1702).
    distribution: isAdmissionFlow || isPass || isPreset,
    addOns: !isPass && type !== ADMISSION_TYPE_GUEST_LIST && isAdmissionFlow,
    advanced: true,
    formFields: true,
    appearance: true,
    vatRate: !isClubCountryItaly,
    // SIAE regulation section is admission/pass only — preset payloads carry just `dirittoPrevendita`
    // (the DDP field in Basic info), not the full SIAE/18App/abbonamento block.
    regulation: (isAdmissionFlow || isPass) && hasItalyRegulationContext && (isSuperAdmin || canExcludeSiaeOffers),
  };

  return SECTION_ORDER.filter((key) => visible[key]);
};
